<form [formGroup]="form" nz-form nzLayout="vertical">
	<div nz-row [nzGutter]="16">
		<div nz-col [nzSpan]="12">
			<nz-form-item>
				<nz-form-label nzRequired>Bank</nz-form-label>
				<nz-form-control nzErrorTip="Please select a bank">
					<nz-select formControlName="bank" nzPlaceHolder="Select bank" [compareWith]="compareSelectValues" [nzDisabled]="mode == 'Edit'">
						<nz-option *ngFor="let item of availableBanks" [nzValue]="item" [nzLabel]="item.name"></nz-option>
					</nz-select>
				</nz-form-control>
			</nz-form-item>
		</div>
	</div>

	<div nz-row [nzGutter]="16">
		<div nz-col [nzSpan]="12">
			<nz-form-item>
				<nz-form-label [nzRequired]="true">Account Name</nz-form-label>
				<nz-form-control>
					<input nz-input formControlName="accountName" placeholder="Account Name" />
				</nz-form-control>
			</nz-form-item>
		</div>
		<div nz-col [nzSpan]="12">
			<nz-form-item>
				<nz-form-label [nzRequired]="true">Account Number</nz-form-label>
				<nz-form-control>
					<input nz-input formControlName="accountNumber" placeholder="Account Number" [readonly]="mode == 'Edit'">
				</nz-form-control>
			</nz-form-item>
		</div>
		<div nz-col [nzSpan]="12">
			<nz-form-item>
				<nz-form-label [nzRequired]="true">From Date</nz-form-label>
				<nz-form-control>
					<nz-date-picker formControlName="fromDate" nzFormat="yyyy-MM-dd" style="width:100%"></nz-date-picker>
				</nz-form-control>
			</nz-form-item>
		</div>
		<div nz-col [nzSpan]="12">
			<nz-form-item>
				<nz-form-label [nzRequired]="false">To Date</nz-form-label>
				<nz-form-control>
					<nz-date-picker formControlName="toDate" nzFormat="yyyy-MM-dd" style="width:100%"></nz-date-picker>
				</nz-form-control>
			</nz-form-item>
		</div>
	</div>
</form>

<div *nzModalFooter>
	<button nz-button nzType="default" (click)="onCancel()">Cancel</button>
	<button nz-button nzType="primary" [disabled]="this.form.invalid" (click)="onSave()">Save</button>
</div>

